var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('md-empty-state',{attrs:{"md-icon":"mood_bad","md-label":_vm.$t('errorLabel'),"md-description":_vm.$t('unexpectedError')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }